import axios from "axios";

function getSensors() {
    return axios.get(`${process.env.VUE_APP_APIURL}/sensors`)
        .then((res) => { return res.data })

}



export default {
    getSensors
};